import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { PieChart as PieIcon } from "lucide-react";

const cogs2024 = [
  { name: "Food Ingredient Costs", value: 50, color: "#3B82F6" },
  { name: "Meat and Buns", value: 30, color: "#EF4444" },
  { name: "Vegetables & Condiments", value: 10, color: "#10B981" },
  { name: "Packaging", value: 10, color: "#F59E0B" },
  { name: "Beverage Costs", value: 20, color: "#8B5CF6" },
  { name: "Catering Supply Costs", value: 15, color: "#EC4899" },
  { name: "Other Costs", value: 5, color: "#22D3EE" }
];

const operatingExpenses2024 = [
  { name: "Operating Expenses", value: 33, color: "#3B82F6" },
  { name: "Staff Wages", value: 17.5, color: "#EF4444" },
  { name: "Truck Maintenance", value: 8.5, color: "#10B981" },
  { name: "Fuel Costs", value: 4.5, color: "#F59E0B" },
  { name: "Utilities", value: 3.5, color: "#8B5CF6" },
  { name: "Marketing & Promotions", value: 4.5, color: "#EC4899" },
  { name: "Administrative Expenses", value: 6.5, color: "#22D3EE" }
];

const PieIncomeStatementRatios = () => {
  const charts = [
    { title: "COGS Breakdown", data: cogs2024 },
    { title: "Operating Expenses Breakdown", data: operatingExpenses2024 }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <div className="flex items-center space-x-2 mb-6">
        <PieIcon className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900 text-center">
          Income Statement Expenses Ratios (2024)
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {charts.map((chart, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-4 flex flex-col items-center min-h-[350px]">
            <h4 className="text-md font-semibold mb-3 text-center">{chart.title}</h4>
            <div className="w-full h-[300px] sm:h-[350px] flex justify-center">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie 
                    data={chart.data} 
                    cx="50%" 
                    cy="45%" 
                    outerRadius={90} 
                    dataKey="value" 
                    label
                  >
                    {chart.data.map((entry, i) => (
                      <Cell key={`cell-${i}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend align="center" layout="horizontal" verticalAlign="top" wrapperStyle={{ marginTop: 10 }} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieIncomeStatementRatios;
